import React from "react";
import { FlexColumn, FlexContainer,MedCol50 } from "../common/Flex";
import styled from "styled-components";


interface RadioOptionProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  children: React.ReactNode;
}

const RadioOptionContainer = styled.div`
  display: flex;
  align-items: baseline; /* Aligns items by their text baseline */

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const JargonRadio = styled.label`
  position: relative;
  padding-left: 36px;
  cursor: pointer;
  display: inline-block;
  line-height: 24px;
  user-select: none;
  flex: 1 1 auto;
  margin-right: 12px;
  margin-bottom: 12px;
`;

const HiddenInput = styled.input`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  position: absolute;
  opacity: 0;
  margin: 0;
`;

const RadioIndicator = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 24px;
  height: 24px;
  border: 2px solid var(--jargon-primary);
  border-radius: 50%;
  background-color: var(--control-background);
  box-sizing: border-box;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: white;
    opacity: 0;
  }

  ${HiddenInput}:checked + & {
    background-color: var(--jargon-primary);
    border-color: var(--jargon-primary);

    &::after {
      opacity: 1;
    }
  }
`;

const RadioOption: React.FC<RadioOptionProps> = ({ id, name, children, ...rest }) => {
  return (
      <RadioOptionContainer>
        <JargonRadio htmlFor={id}>
          <HiddenInput type="radio" id={id} name={name} {...rest} />
          <RadioIndicator />
          {children}
        </JargonRadio>
      </RadioOptionContainer>
  );
};

export default RadioOption;